// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2KBi6","rootCenter":"LoadMoreObserver_rootCenter__1MGqL","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1Dz1X"};